export default "__VITE_ASSET__850b732e__"